// import React, { useState } from "react";
// import { Outlet, NavLink, useNavigate } from "react-router-dom";
// import {
//   AppBar,
//   Box,
//   CssBaseline,
//   Divider,
//   Drawer,
//   IconButton,
//   List,
//   ListItem,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   Toolbar,
//   Typography,
//   Tooltip,
// } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu";
// import LogoutIcon from "@mui/icons-material/Logout";
// import {
//   LayoutDashboard,
//   Users,
//   FileText,
//   Building,
//   Upload,
//   ListChecks,
//   CreditCard,
// } from "lucide-react";

// // In index.js or App.js
// import "@fontsource/nunito";

// // ✅ Nunito font
// import "@fontsource/nunito/400.css";
// import "@fontsource/nunito/500.css";
// import "@fontsource/nunito/600.css";

// const drawerWidth = 260;

// const navLinks = [
//   {
//     name: "Dashboard",
//     path: "/admin/dashboard",
//     icon: <LayoutDashboard size={18} />,
//   },
//   {
//     name: "Company Info Form",
//     path: "/admin/company-info",
//     icon: <LayoutDashboard size={18} />,
//   },
//   { name: "Buyer Info Form", path: "/admin/buyer", icon: <Users size={18} /> },
//   {
//     name: "Voucher Entry",
//     path: "/admin/voucher-entry",
//     icon: <FileText size={18} />,
//   },
//   {
//     name: "Billing Details",
//     path: "/admin/billing-details",
//     icon: <CreditCard size={18} />,
//   },
//   {
//     name: "Company Details",
//     path: "/admin/company-details",
//     icon: <Building size={18} />,
//   },
//   {
//     name: "Buyer Details",
//     path: "/admin/buyer-details",
//     icon: <Users size={18} />,
//   },
//   { name: "Upload PDF", path: "/admin/upload-pdf", icon: <Upload size={18} /> },
//   {
//     name: "Cleared List",
//     path: "/admin/cleared",
//     icon: <ListChecks size={18} />,
//   },
//   {
//     name: "Credit Details",
//     path: "/admin/credit-details",
//     icon: <CreditCard size={18} />,
//   },
//   {
//     name: "Cut List optimizer",
//     path: "/admin/calculator",
//     icon: <Building size={18} />,
//   },

//   {
//     name: "KG / Qty Price Calculator",
//     path: "/admin/calculator2",
//     icon: <Building size={18} />,
//   },

//   {
//     name: "Expense Tracker",
//     path: "/admin/expense-tracker",
//     icon: <CreditCard size={18} />,
//   },
// ];

// export default function DashboardLayout() {
//   const navigate = useNavigate();
//   const [mobileOpen, setMobileOpen] = useState(false);

//   const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

//   const handleLogout = () => {
//     localStorage.removeItem("token");
//     localStorage.removeItem("currentUser");
//     navigate("/", { replace: true });
//   };

//   const drawer = (
//     <Box
//       sx={{
//         height: "100%",
//         display: "flex",
//         flexDirection: "column",
//         bgcolor: "#0f172a",
//         color: "white",
//         fontFamily: "Nunito, sans-serif",
//         overflow: "hidden",
//       }}
//     >
//       {/* Brand Name */}
//       <Toolbar sx={{ px: 2, borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
//         <Typography
//           noWrap
//           sx={{
//             fontWeight: 600,
//             fontSize: "1.2rem",
//             color: "#06b6d4",
//             fontFamily: "Nunito, sans-serif",
//           }}
//         >
//          Sri Murugan Traders
//         </Typography>
//       </Toolbar>

//       {/* Sidebar Links */}
//       <List
//         sx={{
//           mt: 2,
//           px: 1,
//           flexGrow: 1,
//           overflowY: "auto",
//           "&::-webkit-scrollbar": { display: "none" },
//         }}
//       >
//         {navLinks.map((item) => (
//           <ListItem key={item.name} disablePadding sx={{ mb: 1.2 }}>
//             {" "}
//             {/* ✅ gap added */}
//             <ListItemButton
//               component={NavLink}
//               to={item.path}
//               onClick={() => setMobileOpen(false)}
//               disableRipple
//               sx={{
//                 borderRadius: 1.5,
//                 py: 1,
//                 px: 1.6,
//                 fontFamily: "Nunito, sans-serif",
//                 fontSize: "0.95rem",
//                 fontWeight: 500,
//                 color: "rgba(255,255,255,0.85)",
//                 transition: "all 0.25s ease",
//                 "&.active": {
//                   bgcolor: "#0891b2",
//                   color: "#fff",
//                   fontWeight: 600,
//                   "& .MuiListItemIcon-root": { color: "#fff" },
//                 },
//                 "&:hover": {
//                   bgcolor: "rgba(255,255,255,0.08)",
//                   color: "#fff",
//                 },
//               }}
//             >
//               <ListItemIcon sx={{ color: "inherit", minWidth: 34 }}>
//                 {item.icon}
//               </ListItemIcon>
//               <ListItemText
//                 primary={item.name}
//                 primaryTypographyProps={{
//                   fontFamily: "Nunito, sans-serif",
//                   fontSize: "0.95rem",
//                   fontWeight: 500,
//                 }}
//               />
//             </ListItemButton>
//           </ListItem>
//         ))}
//       </List>
//     </Box>
//   );

//   return (
//     <Box sx={{ display: "flex", fontFamily: "Nunito, sans-serif" }}>
//       <CssBaseline />

//       {/* Top AppBar */}
//       <AppBar
//         position="fixed"
//         sx={{
//           width: { sm: `calc(100% - ${drawerWidth}px)` },
//           ml: { sm: `${drawerWidth}px` },
//           bgcolor: "#0f172a",
//           color: "white",
//           fontFamily: "Nunito, sans-serif",
//         }}
//       >
//         <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
//           {/* Mobile menu toggle */}
//           <IconButton
//             color="inherit"
//             edge="start"
//             onClick={handleDrawerToggle}
//             sx={{ mr: 2, display: { sm: "none" } }}
//           >
//             <MenuIcon />
//           </IconButton>

//           {/* Dashboard Title */}
//           <Typography
//             noWrap
//             sx={{
//               fontWeight: 500,
//               fontSize: "1.05rem",
//               fontFamily: "Nunito, sans-serif",
//             }}
//           >
//             Dashboard
//           </Typography>

//           {/* Logout Button on the right */}
//           <Tooltip title="Logout">
//             <IconButton color="inherit" onClick={handleLogout}>
//               <LogoutIcon />
//             </IconButton>
//           </Tooltip>
//         </Toolbar>
//       </AppBar>

//       {/* Sidebar Navigation */}
//       <Box
//         component="nav"
//         sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
//       >
//         {/* Mobile Drawer */}
//         <Drawer
//           variant="temporary"
//           open={mobileOpen}
//           onClose={handleDrawerToggle}
//           ModalProps={{ keepMounted: true }}
//           sx={{
//             display: { xs: "block", sm: "none" },
//             "& .MuiDrawer-paper": { width: drawerWidth, bgcolor: "#0f172a" },
//           }}
//         >
//           {drawer}
//         </Drawer>

//         {/* Desktop Drawer */}
//         <Drawer
//           variant="permanent"
//           sx={{
//             display: { xs: "none", sm: "block" },
//             "& .MuiDrawer-paper": {
//               width: drawerWidth,
//               boxSizing: "border-box",
//               bgcolor: "#0f172a",
//               color: "white",
//               borderRight: "none",
//             },
//           }}
//           open
//         >
//           {drawer}
//         </Drawer>
//       </Box>

//       {/* Main Content */}
//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           p: { xs: 2, sm: 4 },
//           width: { xs: "100%", sm: `calc(100% - ${drawerWidth}px)` },
//           mt: 8,
//           bgcolor: "#eef2ff",
//           minHeight: "100vh",
//         }}
//       >
//         <Outlet />
//       </Box>
//     </Box>
//   );
// }


// import React, { useState } from "react";
// import { Outlet, NavLink, useNavigate } from "react-router-dom";
// import {
//   AppBar,
//   Box,
//   CssBaseline,
//   Drawer,
//   IconButton,
//   List,
//   ListItem,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   Toolbar,
//   Typography,
//   Tooltip,
//   Avatar,
//   Chip,
// } from "@mui/material";
// import MenuIcon from "@mui/icons-material/Menu";
// import LogoutIcon from "@mui/icons-material/Logout";
// import NotificationsIcon from "@mui/icons-material/Notifications";
// import {
//   LayoutDashboard,
//   Users,
//   FileText,
//   Building,
//   Upload,
//   ListChecks,
//   CreditCard,
//   Calculator,
//   TrendingUp,
//   Settings,
//   ChevronRight,
// } from "lucide-react";

// const drawerWidth = 280;

// const navLinks = [
//   {
//     name: "Dashboard",
//     path: "/admin/dashboard",
//     icon: <LayoutDashboard size={20} />,
//     badge: null,
//   },
//   {
//     name: "Company Info",
//     path: "/admin/company-info",
//     icon: <Building size={20} />,
//     badge: null,
//   },
//   {
//     name: "Buyer Info",
//     path: "/admin/buyer",
//     icon: <Users size={20} />,
//     badge: null,
//   },
//   {
//     name: "Voucher Entry",
//     path: "/admin/voucher-entry",
//     icon: <FileText size={20} />,
//     badge: null,
//   },
//   {
//     name: "Billing Details",
//     path: "/admin/billing-details",
//     icon: <CreditCard size={20} />,
//     badge: null,
//   },
//   {
//     name: "Company Details",
//     path: "/admin/company-details",
//     icon: <Building size={20} />,
//     badge: null,
//   },
//   {
//     name: "Buyer Details",
//     path: "/admin/buyer-details",
//     icon: <Users size={20} />,
//     badge: null,
//   },
//   {
//     name: "Upload PDF",
//     path: "/admin/upload-pdf",
//     icon: <Upload size={20} />,
//     badge: null,
//   },
//   {
//     name: "Cleared List",
//     path: "/admin/cleared",
//     icon: <ListChecks size={20} />,
//     badge: null,
//   },
//   {
//     name: "Credit Details",
//     path: "/admin/credit-details",
//     icon: <CreditCard size={20} />,
//     badge: "4",
//   },
//   {
//     name: "Cut List Optimizer",
//     path: "/admin/calculator",
//     icon: <Calculator size={20} />,
//     badge: null,
//   },
//   {
//     name: "Price Calculator",
//     path: "/admin/calculator2",
//     icon: <TrendingUp size={20} />,
//     badge: null,
//   },
//   {
//     name: "Expense Tracker",
//     path: "/admin/expense-tracker",
//     icon: <CreditCard size={20} />,
//     badge: null,
//   },
// ];

// export default function DashboardLayout() {
//   const navigate = useNavigate();
//   const [mobileOpen, setMobileOpen] = useState(false);

//   const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

//   const handleLogout = () => {
//     localStorage.removeItem("token");
//     localStorage.removeItem("currentUser");
//     navigate("/", { replace: true });
//   };

//   const drawer = (
//     <Box
//       sx={{
//         height: "100%",
//         display: "flex",
//         flexDirection: "column",
//         background: "linear-gradient(180deg, #1e293b 0%, #0f172a 100%)",
//         color: "white",
//         fontFamily: "'Inter', sans-serif",
//         overflow: "hidden",
//       }}
//     >
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
//       `}</style>

//       {/* Brand Header */}
//       <Box
//         sx={{
//           px: 3,
//           py: 3,
//           borderBottom: "1px solid rgba(255,255,255,0.08)",
//           background: "rgba(255,255,255,0.03)",
//         }}
//       >
//         <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
//           <Box
//             sx={{
//               width: 40,
//               height: 40,
//               background: "linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)",
//               borderRadius: 2,
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               fontWeight: 800,
//               fontSize: "1.2rem",
//             }}
//           >
//             SM
//           </Box>
//           <Box>
//             <Typography
//               sx={{
//                 fontWeight: 700,
//                 fontSize: "1.1rem",
//                 fontFamily: "'Inter', sans-serif",
//                 letterSpacing: "-0.02em",
//               }}
//             >
//               Sri Murugan Traders
//             </Typography>
//             <Typography
//               sx={{
//                 fontSize: "0.75rem",
//                 color: "rgba(255,255,255,0.5)",
//                 fontWeight: 500,
//               }}
//             >
//               Management Portal
//             </Typography>
//           </Box>
//         </Box>
//       </Box>

//       {/* Navigation Links */}
//       <List
//         sx={{
//           mt: 2,
//           px: 2,
//           flexGrow: 1,
//           overflowY: "auto",
//           "&::-webkit-scrollbar": {
//             width: "6px",
//           },
//           "&::-webkit-scrollbar-track": {
//             background: "rgba(255,255,255,0.05)",
//             borderRadius: "10px",
//           },
//           "&::-webkit-scrollbar-thumb": {
//             background: "rgba(255,255,255,0.2)",
//             borderRadius: "10px",
//             "&:hover": {
//               background: "rgba(255,255,255,0.3)",
//             },
//           },
//         }}
//       >
//         {navLinks.map((item, index) => (
//           <ListItem key={item.name} disablePadding sx={{ mb: 0.5 }}>
//             <ListItemButton
//               component={NavLink}
//               to={item.path}
//               onClick={() => setMobileOpen(false)}
//               disableRipple
//               sx={{
//                 borderRadius: 2,
//                 py: 1.2,
//                 px: 2,
//                 fontFamily: "'Inter', sans-serif",
//                 fontSize: "0.9rem",
//                 fontWeight: 500,
//                 color: "rgba(255,255,255,0.7)",
//                 transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
//                 position: "relative",
//                 overflow: "hidden",
//                 "&::before": {
//                   content: '""',
//                   position: "absolute",
//                   left: 0,
//                   top: 0,
//                   height: "100%",
//                   width: "3px",
//                   background:
//                     "linear-gradient(180deg, #3b82f6 0%, #8b5cf6 100%)",
//                   transform: "scaleY(0)",
//                   transition: "transform 0.2s ease",
//                 },
//                 "&.active": {
//                   background: "rgba(59, 130, 246, 0.15)",
//                   color: "#fff",
//                   fontWeight: 600,
//                   backdropFilter: "blur(10px)",
//                   border: "1px solid rgba(59, 130, 246, 0.3)",
//                   "&::before": {
//                     transform: "scaleY(1)",
//                   },
//                   "& .MuiListItemIcon-root": {
//                     color: "#60a5fa",
//                   },
//                 },
//                 "&:hover": {
//                   background: "rgba(255,255,255,0.08)",
//                   color: "#fff",
//                   transform: "translateX(4px)",
//                   "& .hover-icon": {
//                     opacity: 1,
//                   },
//                 },
//               }}
//             >
//               <ListItemIcon
//                 sx={{
//                   color: "inherit",
//                   minWidth: 40,
//                   transition: "all 0.2s ease",
//                 }}
//               >
//                 {item.icon}
//               </ListItemIcon>
//               <ListItemText
//                 primary={item.name}
//                 primaryTypographyProps={{
//                   fontFamily: "'Inter', sans-serif",
//                   fontSize: "0.9rem",
//                   fontWeight: "inherit",
//                 }}
//               />
//               {item.badge && (
//                 <Chip
//                   label={item.badge}
//                   size="small"
//                   sx={{
//                     height: 20,
//                     fontSize: "0.7rem",
//                     fontWeight: 600,
//                     background:
//                       "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
//                     color: "white",
//                     border: "none",
//                   }}
//                 />
//               )}
//               <ChevronRight
//                 size={16}
//                 className="hover-icon"
//                 style={{
//                   opacity: 0,
//                   transition: "opacity 0.2s ease",
//                   marginLeft: "auto",
//                 }}
//               />
//             </ListItemButton>
//           </ListItem>
//         ))}
//       </List>

//       {/* User Profile Footer */}
//       <Box
//         sx={{
//           p: 2,
//           borderTop: "1px solid rgba(255,255,255,0.08)",
//           background: "rgba(255,255,255,0.03)",
//         }}
//       >
//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             gap: 2,
//             p: 1.5,
//             borderRadius: 2,
//             background: "rgba(255,255,255,0.05)",
//             cursor: "pointer",
//             transition: "all 0.2s ease",
//             "&:hover": {
//               background: "rgba(255,255,255,0.1)",
//             },
//           }}
//         >
//           <Avatar
//             sx={{
//               width: 36,
//               height: 36,
//               background: "linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)",
//               fontWeight: 600,
//             }}
//           >
//             A
//           </Avatar>
//           <Box sx={{ flexGrow: 1 }}>
//             <Typography
//               sx={{
//                 fontSize: "0.85rem",
//                 fontWeight: 600,
//                 fontFamily: "'Inter', sans-serif",
//               }}
//             >
//               Admin User
//             </Typography>
//             <Typography
//               sx={{
//                 fontSize: "0.7rem",
//                 color: "rgba(255,255,255,0.5)",
//                 fontWeight: 500,
//               }}
//             >
//               admin@smt.com
//             </Typography>
//           </Box>
//           <Settings size={18} style={{ opacity: 0.5 }} />
//         </Box>
//       </Box>
//     </Box>
//   );

//   return (
//     <Box sx={{ display: "flex", fontFamily: "'Inter', sans-serif" }}>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
//       `}</style>
//       <CssBaseline />

//       {/* Top AppBar */}
//       <AppBar
//         position="fixed"
//         elevation={0}
//         sx={{
//           width: { sm: `calc(100% - ${drawerWidth}px)` },
//           ml: { sm: `${drawerWidth}px` },
//           background: "white",
//           color: "#1e293b",
//           borderBottom: "1px solid #e2e8f0",
//           fontFamily: "'Inter', sans-serif",
//         }}
//       >
//         <Toolbar
//           sx={{ display: "flex", justifyContent: "space-between", py: 1 }}
//         >
//           {/* Mobile menu toggle */}
//           <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//             <IconButton
//               color="inherit"
//               edge="start"
//               onClick={handleDrawerToggle}
//               sx={{
//                 display: { sm: "none" },
//                 background: "#f1f5f9",
//                 "&:hover": { background: "#e2e8f0" },
//               }}
//             >
//               <MenuIcon />
//             </IconButton>

//             <Box>
//               <Typography
//                 sx={{
//                   fontWeight: 700,
//                   fontSize: "1.4rem",
//                   fontFamily: "'Inter', sans-serif",
//                   letterSpacing: "-0.02em",
//                   color: "#0f172a",
//                 }}
//               >
//                 Dashboard
//               </Typography>
//               <Typography
//                 sx={{
//                   fontSize: "0.75rem",
//                   color: "#64748b",
//                   fontWeight: 500,
//                 }}
//               >
//                 Welcome back, Admin
//               </Typography>
//             </Box>
//           </Box>

//           {/* Right side actions */}
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
           
//             <Tooltip title="Logout">
//               <IconButton
//                 onClick={handleLogout}
//                 sx={{
//                   background: "#fee2e2",
//                   color: "#dc2626",
//                   "&:hover": { background: "#fecaca" },
//                 }}
//               >
//                 <LogoutIcon sx={{ fontSize: 20 }} />
//               </IconButton>
//             </Tooltip>
//           </Box>
//         </Toolbar>
//       </AppBar>

//       {/* Sidebar Navigation */}
//       <Box
//         component="nav"
//         sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
//       >
//         {/* Mobile Drawer */}
//         <Drawer
//           variant="temporary"
//           open={mobileOpen}
//           onClose={handleDrawerToggle}
//           ModalProps={{ keepMounted: true }}
//           sx={{
//             display: { xs: "block", sm: "none" },
//             "& .MuiDrawer-paper": {
//               width: drawerWidth,
//               background: "linear-gradient(180deg, #1e293b 0%, #0f172a 100%)",
//               border: "none",
//             },
//           }}
//         >
//           {drawer}
//         </Drawer>

//         {/* Desktop Drawer */}
//         <Drawer
//           variant="permanent"
//           sx={{
//             display: { xs: "none", sm: "block" },
//             "& .MuiDrawer-paper": {
//               width: drawerWidth,
//               boxSizing: "border-box",
//               background: "linear-gradient(180deg, #1e293b 0%, #0f172a 100%)",
//               color: "white",
//               border: "none",
//             },
//           }}
//           open
//         >
//           {drawer}
//         </Drawer>
//       </Box>

//       {/* Main Content */}
//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           width: { xs: "100%", sm: `calc(100% - ${drawerWidth}px)` },
//           mt: { xs: 8, sm: 9 },
//           background: "#f8fafc",
//           minHeight: "100vh",
//         }}
//       >
//         <Outlet />
//       </Box>
//     </Box>
//   );
// }


import React, { useState, useEffect } from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import {
  AppBar,
  Box,
  CssBaseline,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
  Tooltip,
  Avatar,
  Chip,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";

import {
  LayoutDashboard,
  Users,
  FileText,
  Building,
  Upload,
  ListChecks,
  CreditCard,
  Calculator,
  TrendingUp,
  Settings,
  ChevronRight,
} from "lucide-react";

const drawerWidth = 280;

const navLinks = [
  {
    name: "Dashboard",
    path: "/admin/dashboard",
    icon: <LayoutDashboard size={20} />,
    badge: null,
  },
  {
    name: "Company Info",
    path: "/admin/company-info",
    icon: <Building size={20} />,
    badge: null,
  },
  {
    name: "Buyer Info",
    path: "/admin/buyer",
    icon: <Users size={20} />,
    badge: null,
  },
  {
    name: "Voucher Entry",
    path: "/admin/voucher-entry",
    icon: <FileText size={20} />,
    badge: null,
  },
  {
    name: "Billing Details",
    path: "/admin/billing-details",
    icon: <CreditCard size={20} />,
    badge: null,
  },
  {
    name: "Company Details",
    path: "/admin/company-details",
    icon: <Building size={20} />,
    badge: null,
  },
  {
    name: "Buyer Details",
    path: "/admin/buyer-details",
    icon: <Users size={20} />,
    badge: null,
  },
  {
    name: "Upload PDF",
    path: "/admin/upload-pdf",
    icon: <Upload size={20} />,
    badge: null,
  },
  {
    name: "Cleared List",
    path: "/admin/cleared",
    icon: <ListChecks size={20} />,
    badge: null,
  },
  {
    name: "Credit Details",
    path: "/admin/credit-details",
    icon: <CreditCard size={20} />,
    badge: null,
  },
  {
    name: "Cut List Optimizer",
    path: "/admin/calculator",
    icon: <Calculator size={20} />,
    badge: null,
  },
  {
    name: "Price Calculator",
    path: "/admin/calculator2",
    icon: <TrendingUp size={20} />,
    badge: null,
  },
  {
    name: "Expense Tracker",
    path: "/admin/expense-tracker",
    icon: <CreditCard size={20} />,
    badge: null,
  },
];

export default function DashboardLayout() {
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    // Get user data from localStorage
    const userData = localStorage.getItem("currentUser");
    if (userData) {
      try {
        setCurrentUser(JSON.parse(userData));
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }
  }, []);

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("currentUser");
    navigate("/", { replace: true });
  };

  // Get username for display
  const username = currentUser?.username || "Admin";
  const userInitial = username.charAt(0).toUpperCase();

  const drawer = (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        background: "linear-gradient(180deg, #1e293b 0%, #0f172a 100%)",
        color: "white",
        fontFamily: "'Inter', sans-serif",
        overflow: "hidden",
      }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
      `}</style>

      {/* Brand Header */}
      <Box
        sx={{
          px: 3,
          py: 3,
          borderBottom: "1px solid rgba(255,255,255,0.08)",
          background: "rgba(255,255,255,0.03)",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 1 }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
              background: "white",
            }}
          >
            <img
              src="/logo.jpg"
              alt="Logo"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
              onError={(e) => {
                // Fallback if image doesn't load
                e.target.style.display = "none";
                e.target.parentElement.style.background =
                  "linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)";
                e.target.parentElement.innerHTML =
                  '<span style="font-weight: 800; font-size: 1.2rem; color: white;">SM</span>';
              }}
            />
          </Box>
          <Box>
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: "1.1rem",
                fontFamily: "'Inter', sans-serif",
                letterSpacing: "-0.02em",
              }}
            >
              Sri Murugan Traders
            </Typography>
            <Typography
              sx={{
                fontSize: "0.75rem",
                color: "rgba(255,255,255,0.5)",
                fontWeight: 500,
              }}
            >
              Management Portal
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Navigation Links */}
      <List
        sx={{
          mt: 2,
          px: 2,
          flexGrow: 1,
          overflowY: "auto",
          "&::-webkit-scrollbar": {
            width: "6px",
          },
          "&::-webkit-scrollbar-track": {
            background: "rgba(255,255,255,0.05)",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "rgba(255,255,255,0.2)",
            borderRadius: "10px",
            "&:hover": {
              background: "rgba(255,255,255,0.3)",
            },
          },
        }}
      >
        {navLinks.map((item, index) => (
          <ListItem key={item.name} disablePadding sx={{ mb: 0.5 }}>
            <ListItemButton
              component={NavLink}
              to={item.path}
              onClick={() => setMobileOpen(false)}
              disableRipple
              sx={{
                borderRadius: 2,
                py: 1.2,
                px: 2,
                fontFamily: "'Inter', sans-serif",
                fontSize: "0.9rem",
                fontWeight: 500,
                color: "rgba(255,255,255,0.7)",
                transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                position: "relative",
                overflow: "hidden",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  top: 0,
                  height: "100%",
                  width: "3px",
                  background:
                    "linear-gradient(180deg, #3b82f6 0%, #8b5cf6 100%)",
                  transform: "scaleY(0)",
                  transition: "transform 0.2s ease",
                },
                "&.active": {
                  background: "rgba(59, 130, 246, 0.15)",
                  color: "#fff",
                  fontWeight: 600,
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(59, 130, 246, 0.3)",
                  "&::before": {
                    transform: "scaleY(1)",
                  },
                  "& .MuiListItemIcon-root": {
                    color: "#60a5fa",
                  },
                },
                "&:hover": {
                  background: "rgba(255,255,255,0.08)",
                  color: "#fff",
                  transform: "translateX(4px)",
                  "& .hover-icon": {
                    opacity: 1,
                  },
                },
              }}
            >
              <ListItemIcon
                sx={{
                  color: "inherit",
                  minWidth: 40,
                  transition: "all 0.2s ease",
                }}
              >
                {item.icon}
              </ListItemIcon>
              <ListItemText
                primary={item.name}
                primaryTypographyProps={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: "0.9rem",
                  fontWeight: "inherit",
                }}
              />
              {item.badge && (
                <Chip
                  label={item.badge}
                  size="small"
                  sx={{
                    height: 20,
                    fontSize: "0.7rem",
                    fontWeight: 600,
                    background:
                      "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
                    color: "white",
                    border: "none",
                  }}
                />
              )}
              <ChevronRight
                size={16}
                className="hover-icon"
                style={{
                  opacity: 0,
                  transition: "opacity 0.2s ease",
                  marginLeft: "auto",
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      {/* User Profile Footer */}
      <Box
        sx={{
          p: 2,
          borderTop: "1px solid rgba(255,255,255,0.08)",
          background: "rgba(255,255,255,0.03)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            p: 1.5,
            borderRadius: 2,
            background: "rgba(255,255,255,0.05)",
            cursor: "pointer",
            transition: "all 0.2s ease",
            "&:hover": {
              background: "rgba(255,255,255,0.1)",
            },
          }}
        >
          <Avatar
            sx={{
              width: 36,
              height: 36,
              background: "linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)",
              fontWeight: 600,
            }}
          >
            {userInitial}
          </Avatar>
          <Box sx={{ flexGrow: 1 }}>
            <Typography
              sx={{
                fontSize: "0.85rem",
                fontWeight: 600,
                fontFamily: "'Inter', sans-serif",
              }}
            >
              {username}
            </Typography>
          </Box>
          <Settings size={18} style={{ opacity: 0.5 }} />
        </Box>
      </Box>
    </Box>
  );

  return (
    <Box sx={{ display: "flex", fontFamily: "'Inter', sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
      `}</style>
      <CssBaseline />

      {/* Top AppBar */}
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          background: "white",
          color: "#1e293b",
          borderBottom: "1px solid #e2e8f0",
          fontFamily: "'Inter', sans-serif",
        }}
      >
        <Toolbar
          sx={{ display: "flex", justifyContent: "space-between", py: 1 }}
        >
          {/* Mobile menu toggle */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <IconButton
              color="inherit"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{
                display: { sm: "none" },
                background: "#f1f5f9",
                "&:hover": { background: "#e2e8f0" },
              }}
            >
              <MenuIcon />
            </IconButton>

            <Box>
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: "1.4rem",
                  fontFamily: "'Inter', sans-serif",
                  letterSpacing: "-0.02em",
                  color: "#0f172a",
                }}
              >
                Dashboard
              </Typography>
              <Typography
                sx={{
                  fontSize: "0.75rem",
                  color: "#64748b",
                  fontWeight: 500,
                }}
              >
                Welcome back, {username}
              </Typography>
            </Box>
          </Box>

          {/* Right side actions */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Tooltip title="Logout">
              <IconButton
                onClick={handleLogout}
                sx={{
                  background: "#fee2e2",
                  color: "#dc2626",
                  "&:hover": { background: "#fecaca" },
                }}
              >
                <LogoutIcon sx={{ fontSize: 20 }} />
              </IconButton>
            </Tooltip>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Sidebar Navigation */}
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
      >
        {/* Mobile Drawer */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: "block", sm: "none" },
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              background: "linear-gradient(180deg, #1e293b 0%, #0f172a 100%)",
              border: "none",
            },
          }}
        >
          {drawer}
        </Drawer>

        {/* Desktop Drawer */}
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
              background: "linear-gradient(180deg, #1e293b 0%, #0f172a 100%)",
              color: "white",
              border: "none",
            },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: { xs: "100%", sm: `calc(100% - ${drawerWidth}px)` },
          mt: { xs: 8, sm: 9 },
          background: "#f8fafc",
          minHeight: "100vh",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}